import { AbortSuperFetch } from '../helpers/superFetch';
import UrlBuilder from '../helpers/urlBuilder';
import { getAttributes } from '../helpers/urlBuilder';

const { build } = UrlBuilder;
/**
 * Klasa zawiera metody służące wysyłaniu zapytań o dane do zakładki Studenci do API
 *
 */
class StudentFinder {
  /** Pobieranie kontentu dla tabeli "Moje przedmioty" */
  getStudentList = ({ page, ...rest }: getAttributes, signal: AbortSignal): Promise<Response> => {
    const params: getAttributes = {
      page: page.toString(),
      limit: '1000',
      ...rest,
    };
    const address: string = build('student/ztn_studenci', params);
    return AbortSuperFetch.get(address, signal);
  };

  /** Pobieranie kontentu dla tabeli "Moje przedmioty" */
  getSubjectForStudentList = ({ page, ...rest }: getAttributes, studentId: number, rokSemestrAkademicki: string,  signal: AbortSignal): Promise<Response> => {
    const params: getAttributes = {
      page: page.toString(),
      limit: '1000',
      ...rest,
    };
    const address: string = build(`student/ztn_pojedyczny_student_przydzialy/${studentId}/${rokSemestrAkademicki}`, params);
    return AbortSuperFetch.get(address, signal);
  };
}

export default new StudentFinder();
